// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__impMe","requiredAsterisk":"Info_requiredAsterisk__30KKs"};